import React from 'react';

const TaSignalConfigFormModal = React.lazy(() => import('../components/FormModal'));
const taSignalConfigModalRegistry = {
    personalize_taSignalConfigId: TaSignalConfigFormModal
};
export default taSignalConfigModalRegistry;
